import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { ObjectionsModel } from '../../../../pages/invoicesPage/invoicesPage.Model'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import {
  ActiveSettlementBatchModel,
  ReinvoiceRequestModel,
  SettlementBatchModel,
  SettlementBatchRequestModel
} from './model/settlementBatchs'

export const apiGetSettlementBatchsObjections = async (
  executionCycleId: number
): Promise<ObjectionsModel[] | undefined> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/SettlementBatchs/Objections(${executionCycleId})`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetActiveSettlementBatchs = async (
  executionCycleId: number
): Promise<ActiveSettlementBatchModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/SettlementBatchs/Active(${executionCycleId})`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiPostSettlementBatch = async (
  request: SettlementBatchRequestModel
): Promise<SettlementBatchModel | undefined> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.post(`${apiSuffixUrl}/api/SettlementBatchs`, request).then(
    response => {
      if (response.data) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiPostReinvoiceBatch = async (
  request: ReinvoiceRequestModel
): Promise<SettlementBatchModel | undefined> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.post(`${apiSuffixUrl}/api/SettlementBatchs/Reinvoice`, request).then(
    response => {
      if (response.data) {
        return response.data
      } else {
        return undefined
      }
    }
  )
}
